<template>
  <div class="wrap">
    <div class="banner">
      <i-banner :list="imgList"
                :height="4.21"></i-banner>
    </div>

    <div class="container">
      <menuBar :type="'column'" @menuBar="menuBar"></menuBar>
      <div class="container_item"
           v-for="(item) in columnList"
           :key="item.colId"
           v-show="item.colFl==1"
           @click="toDetails(item.colId)">
        <p class="item_title">
          <span class="title_name">
            <!--<span>{{item.group.egName}}</span>-->
          </span>
          <!--<span class="title_time">{{getTimes(item.lDt)}}</span>-->
        </p>


        <div class="con">
          <div style="position: relative;">
            <div v-if="checkUserMember">
              <get-vip-img v-if="item.cIsvipfree==1"></get-vip-img>
            </div>

            <img class="con_images"
                 :src="item.colThumbnailUrl"
                 alt
                 v-if="item.colThumbnailUrl"/>
            <img class="con_images"
                 src="../../assets/images/default.png"
                 alt
                 v-else/>
          </div>
          <div class="con_right">
            <p class="con_title">{{ item.colTitle }}</p>
            <p class="con_org"
               v-if="item.entity">{{ item.entity.eName }}</p>
            <div class="con_bt">
              <span>{{ item.orderNum }}人已参会</span>
              <span class="con_bt_r"
                    v-if="!item.buyed">
                <!-- <s>¥{{item.originalPrice}}</s> -->
                ¥{{ item.colFees }}
              </span>
              <span class="con_bt_r"
                    style="font-size: 0.26rem"
                    v-if="item.buyed">
                已购
              </span>

              <!-- <span class="con_bt_r"
                    style="font-size: 0.26rem"
                    v-if="item.colFees<=0">
                免费
              </span> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="limits" v-if="columnList.length<1">
        <span>暂无数据</span>
      </div>
  </div>
</template>
<script>
import iBanner from "../container/banner";
import menuBar from "../container/menu";
import weui from "weui.js";
import GetVipImg from '../getvipimg/getVipImg.vue';

import loginService from "../../plugin/extendFn/loginService";
import AppSetting from '../../AppSetting';

export default {
  components: {menuBar, iBanner, GetVipImg},
  data() {
    return {
      checkUserMember: true,
      imgList: [],
      columnList: [],
      uid: "",
      ra_wxUser: null,
      zjList: [], // 1
      kcList: [], // 2
    };
  },
  props: {},
  created() {
    this.$waiting.show(3);
  },
  methods: {
    getUser() {
      console.log("getUser >>>")
      let type = this.ra_wxUser ? this.ra_wxUser.uMemberType : 0;
      if (type == 1 || type == 2) {
        //this.checkUserMember = true;
      }
      console.log("this.ra_wxUser >> ",this.ra_wxUser);
    },
    getData() {
      console.log("getData >>>")
      let myUid = this.ra_wxUser ? this.ra_wxUser.uId : ""
      this.$waiting.hide();
      false && this.$postHttp(AppSetting.baseUrl + "/live/student/list", {
        uid: myUid,
        buy_uid: myUid

      }).then(res => {
        if (res.data.code == 0) {
          this.$waiting.hide();
          let data = res.data.value;
          this.imgList = data.pictures;
        }
      });
      this.$postHttp(AppSetting.baseUrl + "/column/list", {buy_uid: myUid}).then(res => {
        if (res.data.code == 0) {
          let list = res.data.list;
          let uGenre = this.ra_wxUser ? (this.ra_wxUser.uGenre ? this.ra_wxUser.uGenre : 1) : 1;

          let zjList = [];
          let kcList = [];
          list = list.map(item => {
            let auth = item.auths.find(el => {
              return el.memId == parseInt(uGenre);
            });

            item.currentPrice = auth && auth.currentPrice;
            item.originalPrice = auth && auth.originalPrice;

            if (item.colType == 1) {
              zjList.push(item);
            } else {
              kcList.push(item);
            }

            return item;
          });
          console.log(list);
          this.zjList = zjList;
          this.kcList = kcList;
          this.columnList = kcList;
        }
      });
    },
    getTimes(value) {
      return new Date(value).Format("yyyy.MM.dd hh:mm");
    },
    toDetails(id) {
      this.$router.push({
        name: "colDetails",
        query: {type: "column", colId: id}
      });


    },

    menuBar(val) {
      if (val == 1) {
        this.columnList = this.zjList;
      } else if (val == 2) {
        this.columnList = this.kcList;
      }
    },

  },

  async mounted() {
    this.ra_wxUser=await loginService.getLoginUser();

    // alert(1)
    document.title = "会议";

    this.getData();
    this.getUser();
  }
};
</script>
<style scoped lang="scss">
.wrap {
  background: #f4f5f4;
  min-height: 100vh;
}

.banner {
  width: 7.5rem;
}

.limits {
  margin: 0 auto;
  margin-top: 0.7rem;
  font-size: 0.28rem;
  color: #666666;
  text-align: center;
  //line-height: 0.44rem;
  .goMen {
    color: #5bb8f8;
  }
  position: absolute;
	top:44%;
  left: 44%;
}

.container {
  margin-bottom: 0.98rem;

  .container_item {
    background: #ffffff;
    margin-bottom: 0.21rem;
    padding-left: 0.3rem;
    box-sizing: border-box;
    border-bottom: 1px solid #e6e6e6;

    .item_title {
      padding-right: 0.29rem;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      padding-top: 0.16rem;
      padding-bottom: 0.21rem;

      .title_name {
        font-size: 0.26rem;
        color: #666666;
      }

      .title_time {
        font-size: 0.24rem;
        color: #999999;
      }
    }

    .con {
      /*border-bottom: 1px solid #E6E6E6;*/
      box-sizing: border-box;
      padding-bottom: 0.16rem;
      height: 1.77rem;
      display: flex;
      align-items: flex-start;
      flex-shrink: 0;

      .con_right {
        height: 1.62rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }

      .con_images {
        width: 2.84rem;
        height: 1.6rem;
        margin-right: 0.22rem;
      }

      .con_title {
        width: 3.83rem;
        font-size: 0.28rem;
        color: #333333;
        //   line-height: 0.42rem;
        display: -webkit-box;
        -webkit-box-orient: vertical; /*设置弹性盒模型子元素的排列方式*/
        -webkit-line-clamp: 2; /*限制文本行数*/
        font-weight: bold;
        /*white-space: nowrap;      !*超出的空白区域不换行*!*/
        overflow: hidden; /*超出隐藏*/
        text-overflow: ellipsis; /*文本超出显示省略号*/

        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        /* autoprefixer: off */
        -webkit-box-orient: vertical;
        /* autoprefixer: on */
        -webkit-line-clamp: 2;
      }
    }

    .con_org {
      font-size: 0.22rem;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      width: 3.83rem;
      color: #666666;
    }

    .con_bt {
      font-size: 0.2rem;
      color: #999999;
      overflow: hidden;
      line-height: 0.42rem;
      margin-top: 3px;
      span:first-child {
        float: left;
      }

      s {
        font-size: 0.26rem;
        color: #999999;
      }
    }

    .con_bt_r {

      font-size: 0.36rem;
      float: right;
      color: #f00000;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/column/index.vue